<template>
  <div>
    <button
      class="common-button"
      :class="{ 'button-loading': isLoading, 'disable-btn': isDisabled }"
      :type="type"
      :disabled="isDisabled"
      @click="onClick"
    >
      <slot></slot>
      <div class="loader" v-if="isLoading">
        <b-spinner label="Spinning" small></b-spinner>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: 'submit',
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onClick() {
      if (this.isLoading) return;
      this.$emit('onClick');
    },
  },
};
</script>

<style scoped>
.common-button {
  border: none;
  border-radius: 4px;
  font-size: 13px;
  padding: 6.5px 19px;
  text-transform: uppercase;
  font-weight: 500;
  background-color: #333343;
  border: 1px solid #333343;
  color: #ffffff;
  position: relative;
}
.common-button.button-loading {
  background-color: #fff;
  color: #333343;
}
.common-button:disabled {
  background-color: rgba(0, 0, 0, 0.11);
  border: 1px solid rgba(0, 0, 0, 0.13);
  color: rgba(51, 51, 67, 0.29);
}
.common-button:not(.disable-btn):active {
  background-color: #ffffff;
  color: #333343;
}
.loader {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: #ffffff;
  color: #333343;
  cursor: auto;
}
</style>
